import { render, staticRenderFns } from "./DevicesSoldYearsChart.vue?vue&type=template&id=bf98de28&scoped=true&"
import script from "./DevicesSoldYearsChart.vue?vue&type=script&lang=js&"
export * from "./DevicesSoldYearsChart.vue?vue&type=script&lang=js&"
import style0 from "./DevicesSoldYearsChart.vue?vue&type=style&index=0&id=bf98de28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf98de28",
  null
  
)

export default component.exports